import React, { useState } from 'react';
import { Alert, Box, Button, Container, Grid, Paper, TextField, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Seo from '../common/Seo';

const contactDetails = [
	{ label: 'Email', value: 'earth@brokencosmos.com' },
	{ label: 'Location', value: 'Toronto area, Canada' },
	{ label: 'Focus', value: 'Software modernization, integrations, DevOps, UX refinement' },
];

const Contact = () => {
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		company: '',
		message: '',
	});
	const [submitted, setSubmitted] = useState(false);

	const handleChange = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value });
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		setSubmitted(true);
		setFormData({
			name: '',
			email: '',
			company: '',
			message: '',
		});
	};

	return (
		<>
			<Seo
				title="Contact - BrokenCosmos Labs"
				description="Contact BrokenCosmos Labs in the Toronto area to discuss DevOps automation, software modernization, and custom product delivery."
				path="/contact"
			/>
			<Box id="contact" sx={{ py: { xs: 10, md: 14 } }}>
				<Container maxWidth="xl">
					<Grid container spacing={{ xs: 4, md: 5 }}>
						<Grid item xs={12} lg={5}>
							<Typography variant="overline" sx={{ color: '#99f6e4', letterSpacing: '0.12em' }}>
								Contact
							</Typography>
							<Typography variant="h2" component="h1" sx={{ mt: 1.5, mb: 2.5, maxWidth: '10ch' }}>
								Let’s talk about what needs to improve.
							</Typography>
							<Typography variant="body1" sx={{ mb: 4 }}>
								If your software feels harder to maintain than it should, or your current tools are creating drag, we can
								work through what a cleaner and more professional solution looks like.
							</Typography>
							<Paper elevation={0} sx={{ p: 3.5, borderRadius: '28px', backgroundColor: alpha('#0f172a', 0.72) }}>
								{contactDetails.map((item) => (
									<Box key={item.label} sx={{ mb: 2.5, '&:last-child': { mb: 0 } }}>
										<Typography variant="overline" sx={{ color: '#93c5fd', letterSpacing: '0.08em' }}>
											{item.label}
										</Typography>
										<Typography variant="body2" sx={{ color: 'text.primary' }}>
											{item.value}
										</Typography>
									</Box>
								))}
							</Paper>
						</Grid>

						<Grid item xs={12} lg={7}>
							<Paper
								elevation={0}
								sx={{
									p: { xs: 3, md: 4 },
									borderRadius: '28px',
									background: 'linear-gradient(180deg, rgba(15,23,42,0.84) 0%, rgba(15,27,45,0.72) 100%)',
								}}
							>
								{submitted && (
									<Alert severity="success" sx={{ mb: 3, borderRadius: '16px' }}>
										Thanks for reaching out. Your note has been captured in the UI state and the form is ready for backend wiring.
									</Alert>
								)}
								<Box component="form" noValidate onSubmit={handleSubmit}>
									<Grid container spacing={2.5}>
										<Grid item xs={12} md={6}>
											<TextField
												fullWidth
												label="Name"
												name="name"
												value={formData.name}
												onChange={handleChange}
												required
											/>
										</Grid>
										<Grid item xs={12} md={6}>
											<TextField
												fullWidth
												label="Email"
												name="email"
												type="email"
												value={formData.email}
												onChange={handleChange}
												required
											/>
										</Grid>
										<Grid item xs={12}>
											<TextField
												fullWidth
												label="Company"
												name="company"
												value={formData.company}
												onChange={handleChange}
											/>
										</Grid>
										<Grid item xs={12}>
											<TextField
												fullWidth
												label="What are you trying to improve?"
												name="message"
												value={formData.message}
												onChange={handleChange}
												required
												multiline
												rows={6}
											/>
										</Grid>
										<Grid item xs={12}>
											<Button type="submit" variant="contained" size="large">
												Send Inquiry
											</Button>
										</Grid>
									</Grid>
								</Box>
							</Paper>
						</Grid>
					</Grid>
				</Container>
			</Box>
		</>
	);
};

const ContactPage = () => (
	<>
		<Contact />
	</>
);

export default ContactPage;
